import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {Router} from '@angular/router';
 
@Component({
  selector: 'app-sub-add-notes',
  templateUrl: './sub-add-notes.component.html',
  styleUrls: ['./sub-add-notes.component.scss']
})
export class SubAddNotesComponent implements OnInit {
  notes:any;
  notesArr=[];
  name:any;
  imgUrl:any;

  constructor(private toastr: ToastrService,private auth:AuthServiceService,private local:LocalServiceService,private router:Router) { }

  ngOnInit(): void {
    this.getSubNotes();
    // this.getProfileDetail();
  }


  getSubNotes(){
    this.auth.getSubNote().subscribe((response:any)=>{
      // console.log('-------------',response);
      this.notesArr = response.body;
    })

  }

  getProfileDetail(){
    this.auth.getProfile().subscribe((response:any)=>{
      this.name = response.body.userName;
      this.imgUrl = `https://dev.vvip.com.sg:3011/'${response.body.image}`;
      
    },(error)=>{
      if(error.status == 401){
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    })
  }

  addNote(){
     if(this.notes == undefined){
      this.toastr.error('Please enter note');
      return;
     }

     let data = {'description':this.notes};

     this.auth.addNote(data).subscribe((response:any)=>{
       this.notesArr = response.body;
       this.notes = '';
       this.toastr.success('Note Added Successfully');
      //  console.log('hello',response);
     },(e)=>{
       if(e.status == 401){
         this.local.logout();
         this.router.navigate(['/admin']);
       }else{
         this.toastr.error(e.error.message);
       }
     })


     console.log(data)
  }


  deletNote(id){

    const formData = new FormData();

    formData.append('note_id',id);

    let data={'note_id':id};

    this.auth.deleteSubNote(data).subscribe((response:any)=>{
      // console.log('-------------->',response);
      this.toastr.success('Note Deleted Successfully');
      this.notesArr = response.body;
    },(e)=>{
      if(e.status == 401){
        this.local.logout();
        this.router.navigate(['/admin']);
      }else{
        this.toastr.error(e.error.message);
      }
    })

  }

  onImgError(event) { 
    event.target.src = '../../../assets/images/default.png';
}

}
